

export default {
    async SET_TOTAL_GOLD_ORDER(state, totalGoldOrders) {
        state.totalGoldOrders = totalGoldOrders
    },

    async ADD_NEW_GOLD_ORDER(state, order) {
        state.goldOrders.splice(0, 0, order) 
    },
    async SET_GOLD_ORDER(state, goldOrders) {
        state.goldOrders = goldOrders
    },
    async UPDATE_GOLD_ORDER(state, order) {
        const goldOrderIndex = state.goldOrders.findIndex((p) => p.idOrder == order.idOrder)
        Object.assign(state.goldOrders[goldOrderIndex], order)
    },

    REMOVE_GOLD_ORDER(state, idOrder) {
        const goldOrderIndex = state.goldOrders.findIndex((p) => p.idOrder == idOrder)
        state.goldOrders.splice(goldOrderIndex, 1)

    },
    
    

}
 